import React from "react";
import { Severity } from "../../../interfaces/enums/Severity";
import useLightwindow from "../../../../common/hooks/useLightwindow";

import Alert from "../../Alert/Alert";
import Icon from "../../Icon/Icon";
import InsurerLogo from "../../InsurerLogo/InsurerLogo";

interface IQuoteBreakdownSummaryHeaderProps {
    providerId: number;
}

const QuoteBreakdownSummaryHeader: React.FC<IQuoteBreakdownSummaryHeaderProps> = (
    props
) => {
    const { providerId } = props;

    const { openPromotion } = useLightwindow();

    return (
        <React.Fragment>
            <div className="layout-flex-column">
                <div className="layout-flex-row--centered layout-flex-row--justify-spaced gap-l">
                    <InsurerLogo includesAboutInsurerModal providerId={providerId} />

                    <div className="layout-flex-row--centered space-l">
                        <div className="layout-hidden-mobile layout-flex-row--centered">
                            <Icon id="AlertInfo" className="space-s" />
                            <a
                                className="space-xl text-font-size-s"
                                onClick={() => openPromotion("QuoteImportantInfo")}>
                                Important Info
                            </a>
                        </div>
                    </div>
                </div>

                <Alert severity={Severity.Info} className="gap-l" isHighlighted>
                    <span className="text-primary text-bold text-font-size-s text-paragraph">
                        LifeDirect&apos;s service is FREE and doesn&apos;t affect the
                        price of your policy
                    </span>
                </Alert>

                <div className="gap-pre-l layout-flex-row--centered layout-hidden-desktop">
                    <Icon id="AlertInfo" className="space-s" />
                    <a onClick={() => openPromotion("QuoteImportantInfo")}>
                        Important Info
                    </a>
                </div>
            </div>
        </React.Fragment>
    );
};

export default QuoteBreakdownSummaryHeader;
